import React from 'react';
import { Checkbox } from 'semantic-ui-react';

/**
 * Table header component for CDP Reports
 * Renders sortable column headers with visibility controls
 */
const ReportTableHeader = ({
    column,
    order,
    hideColumn = {},
    expandableColumn,
    expandableRowLevel2,
    handleSort,
    handleSelectAll,
    dentistAbbrArr = [],
    allLockedStatus,
    saveAllPayReportByProvider
}) => {
    const direction = order ? 'down' : 'up';

    return (
        <thead>
            <tr>
                {!hideColumn.selectAll && <th className='checkbox-column'>
                    <Checkbox value={0}
                        onChange={(e, { checked }) => handleSelectAll(checked, dentistAbbrArr)} />
                </th>}
                {!hideColumn.lockStatus && <th className="lock-status-column">
                    <div>
                        {<Checkbox className="ms-1"
                            checked={allLockedStatus}
                            onClick={saveAllPayReportByProvider} />} <span className="ml-2">Lock Status</span>
                    </div>
                </th>}
                {!hideColumn.provider && <th className={`cursorPointer ${column === 'sortName' ? 'active' : ''}`}
                    onClick={handleSort('sortName')}>
                    <div><i className={`sort amount ${direction} icon ml-0`}> </i>Provider</div>
                </th>}
                {!hideColumn.ABBR && expandableColumn &&
                    <th className={`cursorPointer ${column === 'ABBR' ? 'active' : ''}`}
                        onClick={handleSort('ABBR')}>
                        <div><i className={`sort amount ${direction} icon ml-0`}> </i>ABBR</div>
                    </th>}
                {!hideColumn.practice &&
                    <th className={`cursorPointer ${column === 'doctorPracticesArray' ? 'active' : ''}`}
                        onClick={handleSort('doctorPracticesArray')}>
                        <div><i className={`sort amount ${direction} icon ml-0`}> </i>Practice</div>
                    </th>}
                {!hideColumn.contractType &&
                    <th className={`cursorPointer ${column === 'contractType' ? 'active' : ''}`}
                        onClick={handleSort('contractType')}>
                        <div><i className={`sort amount ${direction} icon ml-0`}> </i>Contract Type</div>
                    </th>}
                {!hideColumn.workTimeType && expandableColumn &&
                    <th className={`cursorPointer ${column === 'dentistWorkTimeType' ? 'active' : ''}`}
                        onClick={handleSort('dentistWorkTimeType')}>
                        <div><i className={`sort amount ${direction} icon ml-0`}> </i>Work Time Type</div>
                    </th>}
                {!hideColumn.workedDays &&
                    <th className={`cursorPointer ${column === 'numberOfWorkedDays' ? 'active' : ''}`}
                        onClick={handleSort('numberOfWorkedDays')}>
                        <div><i className={`sort amount ${direction} icon ml-0`} />Wrkd Days</div>
                    </th>}
                {!hideColumn.scheduledDays &&
                    <th className={`cursorPointer ${column === 'numberOfScheduledDays' ? 'active' : ''}`}
                        onClick={handleSort('numberOfScheduledDays')}>
                        <div><i className={`sort amount ${direction} icon ml-0`} />Schd Days</div>
                    </th>}
                {!hideColumn.RTOApproved && expandableColumn &&
                    <th className={`cursorPointer ${column === 'workedDays' ? 'active' : ''}`}
                        onClick={handleSort('workedDays')}>
                        <div><i className={`sort amount ${direction} icon ml-0`} />RTO - Approved</div>
                    </th>}
                {!hideColumn.FTOApproved && expandableColumn &&
                    <th className={`cursorPointer ${column === 'workedDays' ? 'active' : ''}`}
                        onClick={handleSort('workedDays')}>
                        <div><i className={`sort amount ${direction} icon ml-0`} />FTO - Approved</div>
                    </th>}
                {!hideColumn.patientVisits &&
                    <th className={`cursorPointer ${column === 'patientVisits' ? 'active' : ''}`}
                        onClick={handleSort('patientVisits')}>
                        <div><i className={`sort amount ${direction} icon ml-0`}> </i>Pat Visits</div>
                    </th>}
                {!hideColumn.bCPV && <th className={`cursorPointer ${column === 'bCPV' ? 'active' : ''}`}
                    onClick={handleSort('bCPV')}>
                    <div><i className={`sort amount ${direction} icon ml-0`} />bCPV</div>
                </th>}
                {!hideColumn.patientVisitsPerDay &&
                    <th className={`cursorPointer ${column === 'patientVisitsPerDay' ? 'active' : ''}`}
                        onClick={handleSort('patientVisitsPerDay')}>
                        <div><i className={`sort amount ${direction} icon ml-0`} />Visits /Day</div>
                    </th>}
                {!hideColumn.rampStartDate && expandableColumn &&
                    <th className={`cursorPointer ${column === 'rampStartDate' ? 'active' : ''}`}
                        onClick={handleSort('rampStartDate')}>
                        <div><i className={`sort amount ${direction} icon ml-0`} />Ramp Start Date</div>
                    </th>}
                {!hideColumn.rampEndDate && expandableColumn &&
                    <th className={`cursorPointer ${column === 'rampEndDate' ? 'active' : ''}`}
                        onClick={handleSort('rampEndDate')}>
                        <div><i className={`sort amount ${direction} icon ml-0`} />Ramp End Date</div>
                    </th>}
                {!hideColumn.procedureDate && expandableRowLevel2 &&
                    <th className={`cursorPointer ${column === 'care' ? 'active' : ''}`}>
                        <div><i className={`sort amount ${direction} icon ml-0`} />Procedure Date</div>
                    </th>}
                {!hideColumn.startEnd && expandableRowLevel2 &&
                    <th className={`cursorPointer ${column === 'startEnd' ? 'active' : ''}`}>
                        <div><i className={`sort amount ${direction} icon ml-0`} />Start - End</div>
                    </th>}
                {!hideColumn.care && <th className={`cursorPointer ${column === 'price' ? 'active' : ''}`}
                    onClick={handleSort('price')}>
                    <div><i className={`sort amount ${direction} icon ml-0`}> </i>Care</div>
                </th>}
                {!hideColumn.writeOffs && <th className={`cursorPointer ${column === 'writeOffPrice' ? 'active' : ''}`}
                    onClick={handleSort('writeOffPrice')}>
                    <div><i className={`sort amount ${direction} icon ml-0`}> </i>Write Offs</div>
                </th>}
                {!hideColumn.adjustments &&
                    <th className={`cursorPointer ${column === 'adjustmentPrice' ? 'active' : ''}`}
                        onClick={handleSort('adjustmentPrice')}>
                        <div><i className={`sort amount ${direction} icon ml-0`}> </i>Adj</div>
                    </th>}
                {!hideColumn.careFraction &&
                    <th className={`cursorPointer ${column === 'careFraction' ? 'active' : ''}`}
                        onClick={handleSort('prodAdjWo')}>
                        <div><i className={`sort amount ${direction} icon ml-0`}> </i>Care Fractn</div>
                    </th>}
                {!hideColumn.collectionsGoxGozTotal && expandableColumn &&
                    <th className={`cursorPointer ${column === 'careFraction' ? 'active' : ''}`}
                        onClick={handleSort('prodAdjWo')}>
                        <div><i className={`sort amount ${direction} icon ml-0`}> </i>Gx,Gz,Col</div>
                    </th>}
                {!hideColumn.bCare && <th className={`cursorPointer ${column === 'bCare' ? 'active' : ''}`}
                    onClick={handleSort('bCare')}>
                    <div><i className={`sort amount ${direction} icon ml-0`}> </i>bCare</div>
                </th>}
                {!hideColumn.totalBasePay &&
                    <th className={`cursorPointer ${column === 'totalBasePay' ? 'active' : ''}`}
                        onClick={handleSort('totalBasePay')}>
                        <div><i className={`sort amount ${direction} icon ml-0`}> </i>Base Pay</div>
                    </th>}
                {!hideColumn.financialNotes &&
                    <th className={`cursorPointer ${column === 'financialNotes' ? 'active' : ''}`}
                        onClick={handleSort('financialNotes')}>
                        <div><i className={`sort amount ${direction} icon ml-0`}> </i>Fin Note</div>
                    </th>}
                {!hideColumn.totalPay && <th className={`cursorPointer ${column === 'procBasedPay' ? 'active' : ''}`}
                    onClick={handleSort('procBasedPay')}>
                    <div><i className={`sort amount ${direction} icon ml-0`}> </i>Total Pay</div>
                </th>}
                {!hideColumn.normalizedPercentageOfBillableCare &&
                    <th className={`cursorPointer ${column === 'normalizedPercentageOfBillableCare' ? 'active' : ''}`}
                        onClick={handleSort('normalizedPercentageOfBillableCare')}>
                        <div><i className={`sort amount ${direction} icon ml-0`}> </i>% of Billable</div>
                    </th>}
            </tr>
        </thead>
    );
};

export default ReportTableHeader;
